import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { sendOtpApi } from "utils/authThunk";
const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [responseMessage, setResponseMessage] = useState(false);
  const dispatch = useDispatch();

  const route = all_routes;
  const navigate = useNavigate();
  const handleSendOtp = async (event) => {
    event.preventDefault();
    console.log("send otp ");
    if (email === "") {
      setResponseMessage(false);
      setMessage("Please Enter Your Email");
      return;
    }
    try {
      let result = await dispatch(sendOtpApi({ email })); // ✅ Use .unwrap()
      console.log("message: ", result);
      if (result?.payload?.success === false) {
        setResponseMessage(false);
        toast.error(result?.payload);
        return;
      } else {
        toast.success(result?.payload?.message);
        setResponseMessage(true);
        localStorage.setItem("email", email);
        setTimeout(() => {
          const Path = route.otp;
          navigate(Path);
        }, 1000);
      }
    } catch (error) {
      console.log(error);
      setResponseMessage(false);
      toast.error("Something Went Wrong");
    }
  };

  return (
    <>
      <div className="main-wrapper">
        <div className="login-content">
          <div className="row">
            <div className="col-md-6 login-bg d-none d-lg-flex">
              <div className="mx-auto">
                <div className="login-carousel-section mb-3">
                  <div className="login-banner">
                    <ImageWithBasePath
                      src="assets/img/auth/auth-1.svg"
                      className="img-fluid"
                      alt="Logo"
                    />
                  </div>
                  <div className="mentor-course text-center">
                    <h3 className="mb-2">
                      Welcome to 
                      {" "}<span className="text-secondary">
                      AIATI in India.
                      </span>{" "}
                    </h3>
                    <p>
                      A trusted platform to manage, deliver, and track aviation learning and training.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6 login-wrap-bg">
              <div className="login-wrapper">
                <div className="loginbox">
                  <div className="w-100">
                    <div className="d-flex align-items-center justify-content-between login-header">
                      <img
                        src="/assets/img/logo/AviationLogo-08.png"
                        alt="Logo"
                        height="70"
                        style={{ height: "70px" }}
                      />
                      <Link to="/admin/login" className="link-1">
                        Back to Login
                      </Link>
                    </div>
                    <div className="topic">
                      <h1 className="fs-32 fw-bold mb-3">Forgot Password</h1>
                      <p className="fs-14 fw-normal mb-0">
                        Enter your email to reset your password.
                      </p>
                    </div>

                    <form className="mb-3 pb-3" onSubmit={handleSendOtp}>
                      <div className="mb-3 position-relative">
                        <label className="form-label">
                          Email<span className="text-danger ms-1">*</span>
                        </label>
                        <div className="position-relative">
                          <input
                            type="email"
                            className="form-control form-control-lg"
                            placeholder="Enter your email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                          />
                          <span>
                            <i className="isax isax-sms input-icon text-gray-7 fs-14" />
                          </span>
                        </div>
                      </div>
                      <div className="d-grid">
                        <button
                          className="btn btn-secondary btn-lg"
                          type="submit"
                        >
                          Submit
                          <i className="isax isax-arrow-right-3 ms-1" />
                        </button>
                      </div>
                    </form>

                    <p className="fs-14 fw-normal d-flex align-items-center justify-content-center">
                      Remember Password?
                      <Link to={route.login} className="link-2 ms-1">
                        Login In
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
